<div
  class="mx-auto flex max-w-xl flex-col items-center gap-4 py-12 text-center"
>
  @switch (issue()) {
    @case (accessIssue.WrongEmail) {
      <pr-empty-state
        image="broken"
        explicitTitle="This referral was sent to a different email address"
        description="Referrals can only be opened with the email address they were sent to."
      />
      <p class="mat-body" data-testid="expected-email">
        This referral was sent to
        <span class="font-semibold">{{ expectedEmail() }}</span>
      </p>
      <p class="mat-body" data-testid="signed-in-email">
        You're signed in as
        <span class="font-semibold">{{ email() }}</span>
      </p>
      <button
        mat-flat-button
        color="primary"
        data-testid="switch-account"
        (click)="switchAccount.emit()"
      >
        <mat-icon>switch_account</mat-icon>
        Sign in as {{ expectedEmail() }}
      </button>
    }
    @case (accessIssue.NotAvailable) {
      <pr-empty-state
        image="broken"
        explicitTitle="This referral isn't available"
        description="You're signed in with the email address this referral was sent to, but it can't be opened. It may have been withdrawn. Please contact the practice that sent it."
      />
      <p class="mat-body" data-testid="signed-in-email">
        You're signed in as
        <span class="font-semibold">{{ email() }}</span>
      </p>
    }
    @default {
      <pr-empty-state
        image="broken"
        explicitTitle="We couldn't open this referral"
        description="Referrals can only be opened with the email address they were sent to."
      />
      @if (email(); as signedInEmail) {
        <p class="mat-body" data-testid="signed-in-email">
          You're signed in as
          <span class="font-semibold">{{ signedInEmail }}</span>
        </p>
      }
      <button
        mat-flat-button
        color="primary"
        data-testid="switch-account"
        (click)="switchAccount.emit()"
      >
        <mat-icon>switch_account</mat-icon>
        Sign in with a different email
      </button>
    }
  }
</div>
